import { JSEncrypt } from 'jsencrypt';
import api from '@/api';
import { post } from '@/utils/http';

// 加密
const encode = (sourceStr, publicKey) => {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  // eslint-disable-next-line prefer-const
  let encodeData = encryptor.encrypt(sourceStr);
  return encodeData;
};

// 解密
const decode = (sourceStr, privateKey) => {
  // eslint-disable-next-line prefer-const
  let decrypt = new JSEncrypt();
  decrypt.setPrivateKey(privateKey);
  // eslint-disable-next-line prefer-const
  let decodeData = decrypt.decrypt(sourceStr);
  return decodeData;
};

const RSAUtils = {
  encode,
  decode,
};

const pwdPublicKeyEncode = async (password) => {
  // eslint-disable-next-line prefer-const
  let publicKey = await post(api.passwordPublicKey, {}).catch(() => {});
  if (!publicKey) {
    return false;
  }
  return RSAUtils.encode(password, publicKey);
};

export { RSAUtils, pwdPublicKeyEncode };
